import { Link } from "gatsby";
import React from "react";
import Image from "~/components/elements/Image";
import { Button, ButtonType } from "~/components/elements/buttons/Button";
import { Icon, IconType } from "~/components/elements/Icon";

const ArticlesPreviewsSection = ({ featured = false, posts, allPosts = false, name, noLimit = false }) => {


	return (
		<>

			<div className="mt-12 grid grid-cols-1 gap-x-6 gap-y-12 border-t border-t-purple pt-12 sm:grid-cols-2 md:grid-cols-3">
				{posts?.map((post, i) => (
					<Link key={`article-${i}`} to={post.uri} className="group space-y-5 md:space-y-8">
						<div className="aspect-h-3 aspect-w-4 overflow-hidden">
							<Image
								image={post?.article?.image}
								className="!absolute transform transition-transform duration-700 ease-in-out group-hover:scale-110"
								objectFit="cover"
							/>
						</div>

						<div className="space-y-1 transition-opacity duration-300 ease-in-out group-hover:opacity-60 md:space-y-3.5">
							<div className="text-sm capitalize text-purple">{post?.article?.type}</div>
							<div className="text-20 !font-medium leading-[1.25]">
								{post.title}{" "}
								<div className="ml-3 inline-block">
									<Icon type="arrowRightDown" />
								</div>
							</div>
						</div>
					</Link>
				))}
			</div>
		</>
	);
};

export default ArticlesPreviewsSection;
